import React, { useEffect, useState } from "react";
import emptyCardImage from "../../assets/images/bank-card-images/default-card-img.png";
import classnames from "classnames";
import { get, isEmpty } from "lodash";
import { isVerticalImg } from "../../utils/image";

const CardImage = (props) => {
  const {
    data,
  } = props

  const [imageUrl, setImageUrl] = useState(emptyCardImage)

  useEffect(() => {
    if (data) {
      setImageUrl(get(data, 'cardImg'))
    }
  }, [data])

  return (
    isEmpty(data) ? (<></>) : (
      <>
        <div
          className={classnames("card-img-wrap", {
            vertical: isVerticalImg(get(data, 'cardImg')),
          })}
        >
          <img src={imageUrl || emptyCardImage} alt={get(data, 'cardName')} />
        </div>
        <span
          className={classnames("card-name", {
            vertical: isVerticalImg(get(data, 'cardImg')),
          })}
        >
          {get(data, 'cardName')}({get(data, 'cardNo')})
        </span>
      </>
    )
  )
}

export default CardImage